import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import TitleField from '../../../fields/TitleField';
import DescriptionField from '../../../fields/DescriptionField';
import AllowFreeDownloadField from '../../../fields/AllowFreeDownloadField';
import LabelsField from '../../../fields/LabelsField';
import LicenseField from '../../../fields/LicenseField';
import LegalDocumentsField from '../../../fields/LegalDocumentsField';
import DisableCommentsField from '../../../fields/DisableCommentsField';
import ScrapsToggleField from '../../../fields/ScrapsToggleField';
import NotifyWatchersField from '../../../fields/NotifyWatchersField';
import FieldsGroup from '../../common/FieldsGroup';
import HorizontalSeparator from '../../common/HorizontalSeparator';
import TagsField from '../../../fields/TagsField';
import RecommendedTagsField from '../../../fields/RecommendedTagsField';
import DisplayOptionsField from '../../../fields/DisplayOptionsField';
import OriginalsVisibilityField from '../../../fields/OriginalsVisibilityField';
import ExclusiveAttachmentsField from '../../../fields/ExclusiveAttachmentsField';
import OriginalsResaleField from '../../../fields/OriginalsResaleField';
import LabelOptionsForm from '../../../common/LabelOptionsForm';
import ImagePreviewWithDisplayOptions from '../../common/ImagePreviewWithDisplayOptions';
import DesktopSubmitLayout from '../DesktopSubmitLayout';
import { SubmitFormContext } from '../../../context';

import s from './OriginalsDeliveryForm.scss';

const OriginalsDeliveryForm = () => {
  const { t } = useTranslation();
  const submitFormContext = useContext(SubmitFormContext);
  const initResponse = submitFormContext?.initResponse;

  if (!initResponse?.deviation) {
    // should never get here
    return null;
  }

  return (
    <DesktopSubmitLayout preview={<ImagePreviewWithDisplayOptions />}>
      <TitleField />
      <LabelOptionsForm />
      <TagsField />
      <RecommendedTagsField withBottomMargin />
      <DescriptionField />

      <FieldsGroup className={s['originals-fields-group']}>
        <OriginalsResaleField />
        <ExclusiveAttachmentsField />
        <OriginalsVisibilityField />
      </FieldsGroup>
      <DisplayOptionsField isLabelHidden={false} />

      <HorizontalSeparator margins="both" />
      <FieldsGroup title={t('deviationSubmit.form.section.advanced.title')} isCollapsible>
        <LabelsField />
        <LicenseField />
        <LegalDocumentsField />
        <DisableCommentsField />
        <ScrapsToggleField />
        <NotifyWatchersField />
        <AllowFreeDownloadField />
      </FieldsGroup>
    </DesktopSubmitLayout>
  );
};
OriginalsDeliveryForm.displayName = 'OriginalsDeliveryForm';

export default OriginalsDeliveryForm;
